import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import TitleMC from '../../../components/TitleMC';
import { formatSummaryDateWithHour } from '../../../../util/dateUtils';

const Step4Partial = ({ methods }) => {
  const { t } = useTranslation('createCampaign');
  const { current_retailer } = useSelector(
    (reduxState) => reduxState.createCampaignReducer
  );

  const campaignValues = methods.getValues();

  const selectedContactGroup = current_retailer?.catalogs?.contact_groups.find(
    (group) => group.id === campaignValues.contact_group_id
  );

  const campaignChunkSize = current_retailer?.catalogs?.qr_campaign_chunk_size;
  const groupCustomersContactsCount = selectedContactGroup?.customers_count;
  const showStages = current_retailer.catalogs?.qr_is_integrated && groupCustomersContactsCount > campaignChunkSize;

  return (
    <div className="tw-wrapper">
      <div id="step-2">
        <TitleMC text={t('step4.title')} variant="BASE" />
        <div className="tw-text-body tw-py-6">
          {t('step4.description')}
        </div>
        <TitleMC text={t('step4.campaignName')} variant="SM" />
        <div className="tw-text-body tw-pb-6">{campaignValues.name}</div>
        <TitleMC text={t('step4.campaignSendAt')} variant="SM" />
        <div className="tw-text-body tw-pb-6">{formatSummaryDateWithHour(campaignValues.send_at)}</div>
        <TitleMC text={t('step4.campaignClientGroup')} variant="SM" />
        <div className="tw-text-body tw-pb-6">{selectedContactGroup?.name}</div>
        {showStages && (
          <>
            <TitleMC text={t('step4.campaignStages')} variant="SM" />
            <div className="tw-text-body tw-pb-6">
              {t('step4.campaignStageAlert', { groupCustomersContactsCount, groupSize: Math.ceil(groupCustomersContactsCount / campaignChunkSize) })}
            </div>
          </>
        )}
      </div>
    </div>
  );
};
export default Step4Partial;
